import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoadWoods = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "road-woods" }),
		/* @__PURE__ */ _jsx("polygon", {
			className: "a",
			points: "20.25 12.013 17.25 20.263 23.25 20.263 20.25 12.013"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 20.25,
			y1: 20.263,
			x2: 20.25,
			y2: 23.263
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "a",
			points: "3.75 0.763 0.75 9.013 6.75 9.013 3.75 0.763"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3.75,
			y1: 9.013,
			x2: 3.75,
			y2: 12.013
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M1.1,23.263A20.256,20.256,0,0,1,21,6.763"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M11.189,23.263a10.531,10.531,0,0,1,4.4-5.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M5.749,23.263a12.53,12.53,0,0,1,.982-2.884"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.388,17.605a9.951,9.951,0,0,1,.934-1.135,9.544,9.544,0,0,1,1.036-1.044"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12.948,13.494A14.534,14.534,0,0,1,15.6,12.232"
		})
	]
});
export default SvgRoadWoods;
